module.exports = __webpack_public_path__ + "svgs/no-inquiry-prescription.79939669.svg";